import useSWRImmutable from "swr/immutable";
import authAxios from "../../helpers/authAxios";
import { mutate } from "swr";

export const getProjectList = (url: string): Promise<any> => authAxios.get(url).then((resp) => resp?.data?.data);

export const getTaskSubtskList = (url: string): Promise<any> => authAxios.get(url).then((resp) => resp?.data?.result);

export const getLogsList = (url: string): Promise<any> => authAxios.get(url).then((resp) => resp?.data?.data);

export const getSpentTime = (url: string): Promise<any> => authAxios.get(url).then((resp) => resp?.data?.result);


export const useProjectList = (limit: number, searchQuery: string) => {
  const { data, error } = useSWRImmutable(
    `/timer-logs/projects/list?limit=${limit}&searchQuery=${searchQuery}`,
    getProjectList
  );
  return {
    projectList: data,
    isProjectListLoading: !error && !data,
    isError: error,
  };
};


export const useGetSpentTime = (date: any) => {
  const key = `timer-logs/get-total-spent-time?date=${date}`;

  const { data, error } = useSWRImmutable(
    key,
    getSpentTime
  );

  const refetchTotalTime = () => {
    mutate(key);
  };

  return {
    totalSpentTime: data,
    isSpentTimeLoading: !error && !data,
    isSpentTimeError: error,
    refetchTotalTime
  };
};


export const useTaskSubtaskList = (projectId: string, limit: number, searchQuery: string) => {
  const { data, error } = useSWRImmutable(
    `timer-logs/task-subtask-list/${projectId}?limit=${limit}&searchQuery=${searchQuery}`,
    getTaskSubtskList
  );
  return {
    taskSubtaskList: data,
    isTaskSubtaskListLoading: !error && !data,
    isTaskError: error,
  };
}

export const useLogsList = (date: string, sortOrder: string) => {
  const key = `timer-logs/list?date=${date}&orderBy=${sortOrder}`;

  const { data, error } = useSWRImmutable(key, getLogsList);

  const refetch = () => {
    mutate(key);
  };

  return {
    logsList: data,
    isLogListLoading: !error && !data,
    isLogError: error,
    refetch
  };
}

export const startTask = (
  formData: any
) =>
  authAxios.post(
    `timer-logs/start-task`,
    formData
  );

export const stopTask = (
  logId: any
) =>
  authAxios.post(
    `timer-logs/stop-task/${logId}`
  );


export const updateTask = (
  logId: any, formData: any
) =>
  authAxios.put(
    `timer-logs/update-task-subTask/${logId}`,
    formData
  );

export const deleteTask = (logId: string) =>
  authAxios.delete(
    `timer-logs/log/${logId}`,
  );



